// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + "36d564533bac8c7b7dd7" + ".bundle.js";
};